export default {"src":"/_next/static/media/terminal.e0524e3f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};